import React from 'react'
import Typography from '../../components/Typography'

const RFA_Subheader: React.FC<any> = () => (
  <Typography variant="subtitle2" style={{ padding: '15px 0' }}>
    Attach the Doctor’s First Report of Occupational Injury or Illness, Form
    DLSR 5021, a Treating Physician’s Progress Report, DWC Form PR-2, or
    equivalent narrative report substantiating the requested treatment.{' '}
  </Typography>
)

export default RFA_Subheader
